"use client"

import * as React from "react"
import { BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, LabelList, Cell } from 'recharts';
import {
    Card, CardContent, CardHeader, CardTitle, CardDescription,
} from "src/@/components/ui/card"
import { ChartContainer } from "src/@/components/ui/chart"
import { Tooltip as ShadTooltip, TooltipContent as ShadTooltipContent, TooltipProvider, TooltipTrigger } from "src/@/components/ui/tooltip"
import { Info } from "lucide-react"
import EmptyContentGhost from "src/components/EmptyContentGhost"

const COLORS = ['#c4b5fd', '#a78bfa', '#8b5cf6', '#7c3aed', '#6d28d9'];

const chartConfig = {
    count: { label: "Quantidade", color: "#8b5cf6" },
};

export function GraficoDistribuicaoValor({ chartData = [] }) {
    return (
        <Card className="w-full">
            <CardHeader className="flex items-center gap-2 space-y-0 border-b border-gray-50 py-3 sm:flex-row">
                <div className="grid flex-1 gap-1 text-center sm:text-left">
                    <div className="flex items-center gap-1">
                        <CardTitle>Distribuição por Faixa de Valor</CardTitle>
                        <TooltipProvider>
                            <ShadTooltip>
                                <TooltipTrigger asChild>
                                    <Info className="w-3.5 h-3.5 text-gray-400 cursor-help" />
                                </TooltipTrigger>
                                <ShadTooltipContent side="top" className="max-w-xs text-xs">
                                    <p>Quantidade de negocios agrupados por faixa de valor (0-1k, 1k-5k, 5k-10k, 10k-50k, 50k+), mostrando onde se concentra o volume</p>
                                </ShadTooltipContent>
                            </ShadTooltip>
                        </TooltipProvider>
                    </div>
                    <CardDescription>Quantidade de negócios por faixa de valor</CardDescription>
                </div>
            </CardHeader>
            <CardContent>
                {chartData.length === 0 ? (
                    <EmptyContentGhost />
                ) : (
                    <ChartContainer className="w-full h-[350px]" config={chartConfig}>
                        <BarChart data={chartData} margin={{ top: 20, right: 20, left: 0, bottom: 5 }}>
                            <CartesianGrid strokeDasharray="3 3" />
                            <XAxis dataKey="faixa" />
                            <YAxis />
                            <Tooltip />
                            <Bar dataKey="count" radius={[4, 4, 0, 0]}>
                                {chartData.map((entry, index) => (
                                    <Cell key={`cell-${index}`} fill={COLORS[index % COLORS.length]} />
                                ))}
                                <LabelList dataKey="count" position="top" fontSize={14} />
                            </Bar>
                        </BarChart>
                    </ChartContainer>
                )}
            </CardContent>
        </Card>
    )
}
